<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
  <div class="container-fluid">
    <a
      class="h4 mb-0 text-white text-uppercase navbar-page-title"
      routerLinkActive="active"
      >{{ getTitle() }}</a
    >
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link pr-0" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img
                alt="Image placeholder"
                [src]="
                  company?.foto
                    ? company?.foto
                    : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                "
              />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                company?.nomeFantasia
              }}</span>
            </div>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bem vindo(a)!</h6>
          </div>
          <a
            routerLinkActive="active"
            [routerLink]="['/company-profile']"
            class="dropdown-item"
          >
            <i class="ni ni-single-02"></i>
            <span>Perfil</span>
          </a>
          <a class="dropdown-item" (click)="logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
